import api from "@/lib/api";

export const inputCls =
  "w-full h-11 rounded-xl border border-sky-200 bg-white px-3 text-sky-950 placeholder:text-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-400 transition-shadow";
export const btnPrimary =
  "inline-flex items-center justify-center gap-2 h-11 px-5 rounded-full bg-sky-500 text-white font-bold hover:bg-sky-600 active:scale-[0.97] transition-[background-color,transform] disabled:opacity-50";
export const btnGhost =
  "inline-flex items-center justify-center gap-2 h-10 px-4 rounded-full border border-sky-300 text-sky-700 font-semibold bg-white/70 hover:bg-sky-100 transition-colors disabled:opacity-50";
export const card = "rounded-3xl bg-white/80 backdrop-blur-xl border border-sky-100 shadow-[0_10px_40px_-15px_rgba(14,165,233,0.35)]";
export const dialogCls = "bg-white text-sky-950 border-sky-100 max-h-[90vh] overflow-y-auto";

export const usd = (n) =>
  `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const waLink = (num, text) =>
  `https://wa.me/${String(num || "").replace(/\D/g, "")}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const errMsg = (e, fallback = "Something went wrong") => e?.response?.data?.detail || fallback;

export async function uploadToCloudinary(file, onProgress) {
  const resourceType = (file.type || "").startsWith("video/") ? "video" : "image";
  const { data: sig } = await api.get("/cloudinary/signature", { params: { resource_type: resourceType } });
  const form = new FormData();
  form.append("file", file);
  form.append("api_key", sig.api_key);
  form.append("timestamp", sig.timestamp);
  form.append("signature", sig.signature);
  form.append("folder", sig.folder);
  const res = await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `https://api.cloudinary.com/v1_1/${sig.cloud_name}/${resourceType}/upload`);
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress?.(Math.round((e.loaded / e.total) * 100));
    xhr.onload = () => (xhr.status < 300 ? resolve(JSON.parse(xhr.responseText)) : reject(new Error("Upload failed")));
    xhr.onerror = () => reject(new Error("Network error"));
    xhr.send(form);
  });
  return { url: res.secure_url, type: resourceType };
}

export function optimizedUrl(url) {
  return url.replace("/upload/", "/upload/f_auto,q_auto/");
}

export function TradeBackdrop() {
  const bars = [38, 62, 45, 80, 55, 92, 70, 110, 88, 125, 100, 140];
  return (
    <svg aria-hidden className="absolute inset-0 w-full h-full opacity-[0.18] pointer-events-none" preserveAspectRatio="none" viewBox="0 0 600 200">
      {bars.map((h, i) => {
        const up = i % 3 !== 1;
        const x = 20 + i * 48;
        return (
          <g key={x} className={up ? "fill-white" : "fill-sky-900"}>
            <rect x={x + 9} y={190 - h - 18} width="2" height={h + 30} />
            <rect x={x} y={190 - h} width="20" height={h * 0.6} rx="3" />
          </g>
        );
      })}
      <polyline fill="none" stroke="white" strokeWidth="3" points="0,170 80,150 160,158 240,120 320,128 400,90 480,70 600,30" />
    </svg>
  );
}
